module.exports = __webpack_public_path__ + "img/union-pay.f028d404.png";